/* eslint-disable max-lines */

const CouponMarketStringTemplate = _TL_('Offer details: Offer expires {{expiryDate}}. Valid only for new Microsoft Advertising customers in the {{market}} who are first party recipients of the offer email. A new Microsoft Advertising customer is one that has not had an active Microsoft Advertising account before. Limit one promotional offer per new Microsoft Advertising customer.');
const CouponRedeemStringTemplate = _TL_('To redeem this offer, customer must create a new Microsoft Advertising account with a primary payment method on file. Once customer completes Microsoft Advertising new customer account setup and spends at least {{spendValue}} on advertising charges excluding taxes, the promotional credit of {{couponValue}} will automatically be applied toward additional advertising spend thereafter, until credit is exhausted or the offer expires.');
const BundleCouponRedeemStringTemplate = _TL_('To redeem this offer, customer must create a new Microsoft Advertising account with a primary payment method on file. Once customer completes Microsoft Advertising new customer account setup and spends at least {{spendValue}} on advertising charges excluding taxes, the promotional credit of {{couponValue}} with a maximum discount of {{maxCouponValue}} will automatically be applied toward additional advertising spend thereafter, until credit is exhausted or the offer expires.');
const CouponPaymentStringTemplate = _TL_('For prepay accounts: the minimum qualifying ad spend amount is deducted directly from prepay funds. For postpay threshold accounts: the primary payment method is charged to collect the minimum qualifying ad spend once the account threshold is met. Customers are responsible for the payment of any taxes incurred. If you create your Microsoft Advertising account in a different currency than the one in which your promotional credit has been awarded, the actual amount of the promotional credit may be subject to foreign currency fluctuations. Any portion of the credit not used within ninety (90) days of credit award will expire and cannot be carried over or restored even if the Microsoft Advertising customer switches their payment method. If customer payment method fails, the promotional credit will not be applied. Microsoft Advertising will continue to run and accrue costs after any promotional credit has been exhausted. This offer may not be combined with any other offer, promotional code coupon or discount, separated, redeemed for cash, transferred, sold, or bartered. Microsoft, in its sole discretion, may close your account for any suspected abuse of this offer. Neither the original advertising qualifying spend nor the promotional credit are refundable, in whole or in part. See Microsoft Advertising Terms and Conditions for more details at sign-up. Other terms and conditions may apply. Microsoft reserves the right to cancel, change, or suspend this offer at any time without notice.');

export const CouponTemplates = {
  Default: {
    banner: _TL_('Get started with Microsoft Advertising and receive {{bannerCouponValue}} ads credits when you spend {{bannerSpendValue}}.'),
    header: _TL_('GET {{couponValue}} IN SEARCH ADVERTISING WHEN YOU SPEND {{spendValue}} IN MICROSOFT ADVERTISING.'),
    contentMarket: CouponMarketStringTemplate,
    contentRedeem: CouponRedeemStringTemplate,
    contentPayment: CouponPaymentStringTemplate,
  },
  Bundle: {
    banner: _TL_('Get started with Microsoft Advertising and receive {{bannerCouponValue}} in advertising credit for every {{bannerSpendValue}} you spend, with a maximum discount of {{bannerMaxCouponValue}}.'),
    header: _TL_('GET {{couponValue}} IN SEARCH ADVERTISING CREDIT WHEN YOU SPEND {{spendValue}}, WITH A MAXIMUM DISCOUNT OF {{maxCouponValue}}.'),
    contentMarket: CouponMarketStringTemplate,
    contentRedeem: BundleCouponRedeemStringTemplate,
    contentPayment: CouponPaymentStringTemplate,
  },
};

export const CouponTemplateMapping = isBundleCoupon => [
  {
    sourceIdList: [
      'en-us-acq-pmaxlanding-src_edgecoup-sub_googedge-exp-cou',
      'en-us-acq-pmaxlanding-src_edgecoup-sub_fbedge-exp-cou',
      'en-us-acq-pmaxlanding-src_edgecoup-sub_googedge-exp-cou_t',
      'en-us-acq-pmaxlanding-src_edgecoup-sub_fbedge-exp-cou_t',
      'en-us-acq-pmaxlanding-src_edgecoup-sub_googedge-exp-cou_c',
      'en-us-acq-pmaxlanding-src_edgecoup-sub_fbedge-exp-cou_c',
    ],
    template: isBundleCoupon ? CouponTemplates.Bundle : CouponTemplates.Default,
    values: isBundleCoupon ? {
      bannerCouponValue: _TL_('$100'),
      bannerSpendValue: _TL_('$50'),
      bannerMaxCouponValue: _TL_('$500'),
      couponValue: _TL_('$100'),
      spendValue: _TL_('$50'),
      maxCouponValue: _TL_('$500'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('United States'),
    } : {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('United States'),
    },
  },
  {
    sourceIdList: [
      'en-us-acq-pmaxlanding-src_boost-sub_rivercard-flx_fy24',
      'en-us-acq-pmaxlanding-src_boost-sub_rivercard-flx_fy24goog',
      'en-us-acq-pmaxlanding-src_boost-sub_rivercard-flx_fy24meta',
      'en-us-acq-pmaxlanding-src_boost-sub_spotlight-flx_fy24',
      'en-us-acq-pmaxlanding-src_boost-sub_spotlight-flx_fy24goog',
      'en-us-acq-pmaxlanding-src_boost-sub_spotlight-flx_fy24meta',
      'en-us-acq-pmaxlanding-src_boost-sub_prong1-flx_fy24',
      'en-us-acq-pmaxlanding-src_boost-sub_prong1-flx_fy24goog',
      'en-us-acq-pmaxlanding-src_boost-sub_prong1-flx_fy24meta',
      'en-us-acq-pmaxlanding-src_boost-sub_prong2-flx_fy24',
      'en-us-acq-pmaxlanding-src_boost-sub_prong2-flx_fy24goog',
      'en-us-acq-pmaxlanding-src_boost-sub_prong2-flx_fy24meta',
      'en-us-acq-pm-src_ggl-sub_gglsnb-flx_fy25pmaxlite',
      'en-us-acq-pm-src_ggl-sub_gglsc-flx_fy25pmaxlite',
      'en-us-acq-pm-src_ggl-sub_gglsb-flx_fy25pmaxlite',
      'en-us-acq-onemsft-src_bingsearchflyout-sub_evgr-flx_fy25bngflyout',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2026'),
      market: _TL_('United States'),
    },
  },
  // Paid media coupons moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'en-us-acq-pm-src_ggl-sub_gglsb',
      'en-us-acq-pm-src_ggl-sub_gglsc',
      'en-us-acq-pm-src_ggl-sub_gglsnb',
      'en-us-acq-pm-src_msa-sub_mssb',
      'en-us-acq-pm-src_msa-sub_mssco',
      'en-us-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('United States'),
    },
  },
  // Edge + BingPlaces + Webmaster Tools coupons moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'en-us-acq-pmaxlanding-src_edgecoup-sub_googedge-flx_fy24',
      'en-us-acq-pmaxlanding-src_edgecoup-sub_fbedge-flx_fy24',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googbusiness',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googlogin',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_metalogin',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_msftlogin',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_email_goog',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_email_nogoog',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_googbusiness',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_googlogin',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_metalogin',
      'en-us-acq-onemsft-src_bingplaces-sub_bpui-flx_msftlogin',
      'en-us-acq-pmaxlanding-src_webmastertools-sub_wmtui',
      'en-us-acq-pmaxlanding-src_webmastertools-sub_wmtemail',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('United States'),
    },
  },
  {
    sourceIdList: [
      'en-de-acq-pm-src_ggl-sub_gglsb',
      'en-de-acq-pm-src_ggl-sub_gglsc',
      'en-de-acq-pm-src_ggl-sub_gglsnb',
      'en-de-acq-pm-src_msa-sub_mssb',
      'en-de-acq-pm-src_msa-sub_mssco',
      'en-de-acq-pm-src_msa-sub_mssnb',
      'de-de-acq-pm-src_ggl-sub_gglsb',
      'de-de-acq-pm-src_ggl-sub_gglsc',
      'de-de-acq-pm-src_ggl-sub_gglsnb',
      'de-de-acq-pm-src_msa-sub_mssb',
      'de-de-acq-pm-src_msa-sub_mssco',
      'de-de-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Germany'),
    },
  },
  // Edge + BingPlaces + Webmaster Tools coupons moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'de-de-acq-pmaxlanding-src_edgecoup-sub_googedge-flx_fy24',
      'de-de-acq-pmaxlanding-src_edgecoup-sub_fbedge-flx_fy24',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googbusiness',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googlogin',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_metalogin',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_msftlogin',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_email_goog',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_email_nogoog',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_googbusiness',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_googlogin',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_metalogin',
      'de-de-acq-onemsft-src_bingplaces-sub_bpui-flx_msftlogin',
      'de-de-acq-pmaxlanding-src_webmastertools-sub_wmtui',
      'de-de-acq-pmaxlanding-src_webmastertools-sub_wmtemail',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Germany'),
    },
  },
  {
    sourceIdList: [
      'en-fr-acq-pm-src_ggl-sub_gglsb',
      'en-fr-acq-pm-src_ggl-sub_gglsc',
      'en-fr-acq-pm-src_ggl-sub_gglsnb',
      'en-fr-acq-pm-src_msa-sub_mssb',
      'en-fr-acq-pm-src_msa-sub_mssco',
      'en-fr-acq-pm-src_msa-sub_mssnb',
      'fr-fr-acq-pm-src_ggl-sub_gglsb',
      'fr-fr-acq-pm-src_ggl-sub_gglsc',
      'fr-fr-acq-pm-src_ggl-sub_gglsnb',
      'fr-fr-acq-pm-src_msa-sub_mssb',
      'fr-fr-acq-pm-src_msa-sub_mssco',
      'fr-fr-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('France'),
    },
  },
  // Webmaster Tools coupon moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'fr-fr-acq-pmaxlanding-src_webmastertools-sub_wmtui',
      'fr-fr-acq-pmaxlanding-src_webmastertools-sub_wmtemail',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('France'),
    },
  },
  {
    sourceIdList: [
      'en-uk-acq-pm-src_ggl-sub_gglsb',
      'en-uk-acq-pm-src_ggl-sub_gglsc',
      'en-uk-acq-pm-src_ggl-sub_gglsnb',
      'en-uk-acq-pm-src_msa-sub_mssb',
      'en-uk-acq-pm-src_msa-sub_mssco',
      'en-uk-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 GBP'),
      bannerSpendValue: _TL_('200 GBP'),
      couponValue: _TL_('£400'),
      spendValue: _TL_('£200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('UK'),
    },
  },
  // Edge + BingPlaces + Webmaster Tools coupons moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'en-uk-acq-pmaxlanding-src_edgecoup-sub_googedge-flx_fy24',
      'en-uk-acq-pmaxlanding-src_edgecoup-sub_fbedge-flx_fy24',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googbusiness',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googlogin',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_metalogin',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_msftlogin',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_email_goog',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_email_nogoog',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_googbusiness',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_googlogin',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_metalogin',
      'en-gb-acq-onemsft-src_bingplaces-sub_bpui-flx_msftlogin',
      'en-gb-acq-pmaxlanding-src_webmastertools-sub_wmtui',
      'en-gb-acq-pmaxlanding-src_webmastertools-sub_wmtemail',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 GBP'),
      bannerSpendValue: _TL_('200 GBP'),
      couponValue: _TL_('£400'),
      spendValue: _TL_('£200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('UK'),
    },
  },
  {
    sourceIdList: [
      'en-ca-acq-pm-src_ggl-sub_gglsb',
      'en-ca-acq-pm-src_ggl-sub_gglsc',
      'en-ca-acq-pm-src_ggl-sub_gglsnb',
      'en-ca-acq-pm-src_msa-sub_mssb',
      'en-ca-acq-pm-src_msa-sub_mssco',
      'en-ca-acq-pm-src_msa-sub_mssnb',
      'fr-ca-acq-pm-src_ggl-sub_gglsb',
      'fr-ca-acq-pm-src_ggl-sub_gglsc',
      'fr-ca-acq-pm-src_ggl-sub_gglsnb',
      'fr-ca-acq-pm-src_msa-sub_mssb',
      'fr-ca-acq-pm-src_msa-sub_mssco',
      'fr-ca-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 CAD'),
      bannerSpendValue: _TL_('300 CAD'),
      couponValue: _TL_('CA$600'),
      spendValue: _TL_('CA$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Canada'),
    },
  },
  // BingPlaces + Webmaster Tools coupons moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googbusiness',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googlogin',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_metalogin',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_msftlogin',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_email_goog',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_email_nogoog',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_googbusiness',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_googlogin',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_metalogin',
      'en-ca-acq-onemsft-src_bingplaces-sub_bpui-flx_msftlogin',
      'en-ca-acq-pmaxlanding-src_webmastertools-sub_wmtui',
      'en-ca-acq-pmaxlanding-src_webmastertools-sub_wmtemail',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 CAD'),
      bannerSpendValue: _TL_('300 CAD'),
      couponValue: _TL_('CA$600'),
      spendValue: _TL_('CA$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Canada'),
    },
  },
  {
    sourceIdList: [
      'en-au-acq-pm-src_ggl-sub_gglsb',
      'en-au-acq-pm-src_ggl-sub_gglsc',
      'en-au-acq-pm-src_ggl-sub_gglsnb',
      'en-au-acq-pm-src_msa-sub_mssb',
      'en-au-acq-pm-src_msa-sub_mssco',
      'en-au-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 AUD'),
      bannerSpendValue: _TL_('300 AUD'),
      couponValue: _TL_('A$600'),
      spendValue: _TL_('A$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Australia'),
    },
  },
  // BingPlaces + Webmaster Tools coupons moved to FY27 (expire June 30, 2027)
  {
    sourceIdList: [
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googbusiness',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_googlogin',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_metalogin',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_analytics_msftlogin',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_email_goog',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_email_nogoog',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_googbusiness',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_googlogin',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_metalogin',
      'en-au-acq-onemsft-src_bingplaces-sub_bpui-flx_msftlogin',
      'en-au-acq-pmaxlanding-src_webmastertools-sub_wmtui',
      'en-au-acq-pmaxlanding-src_webmastertools-sub_wmtemail',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 AUD'),
      bannerSpendValue: _TL_('300 AUD'),
      couponValue: _TL_('A$600'),
      spendValue: _TL_('A$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Australia'),
    },
  },
  {
    sourceIdList: [
      'ja-jp-acq-pm-src_ggl-sub_gglsb',
      'ja-jp-acq-pm-src_ggl-sub_gglsc',
      'ja-jp-acq-pm-src_ggl-sub_gglsnb',
      'ja-jp-acq-pm-src_msa-sub_mssb',
      'ja-jp-acq-pm-src_msa-sub_mssco',
      'ja-jp-acq-pm-src_msa-sub_mssnb',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('60000 YEN'),
      bannerSpendValue: _TL_('30000 YEN'),
      couponValue: _TL_('¥60000'),
      spendValue: _TL_('¥30000'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Japan'),
    },
  },
  {
    sourceIdList: [
      'en-us-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'en-us-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'en-us-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'en-us-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'en-us-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'en-us-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'en-us-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'en-us-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
      'en-us-acq-pm-src_dis-sub_ttd-flx_fy26hldycpn',
      'en-us-acq-pm-src_dis-sub_ttd-flx_fy26hldysmrtr',
      'en-us-acq-pm-src_li-sub_sta-flx_fy26cpn01',
      'en-us-acq-pm-src_li-sub_sta-flx_fy26cpn02',
      'en-us-acq-pm-src_li-sub_sta-flx_fy26clbrtsmrtr',
      'en-us-acq-pm-src_li-sub_sta-flx_fy26smrtrspnd',
      'en-us-acq-pm-src_li-sub_sta-flx_fy26msrblrslts',
      'en-us-acq-pm-src_li-sub_sta-flx_fy26aipwrdprf',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('United States'),
    },
  },
  {
    sourceIdList: [
      'en-us-acq-other-src_ntr-sub_seasonal-flx_signupwgoogem1',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2026'),
      market: _TL_('United States'),
    },
  },
  {
    sourceIdList: [
      'en-au-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'en-au-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'en-au-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'en-au-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'en-au-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'en-au-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'en-au-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'en-au-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 AUD'),
      bannerSpendValue: _TL_('300 AUD'),
      couponValue: _TL_('A$600'),
      spendValue: _TL_('A$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Australia'),
    },
  },
  {
    sourceIdList: [
      'en-ca-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'en-ca-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'en-ca-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'en-ca-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'en-ca-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'en-ca-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'fr-ca-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'fr-ca-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'fr-ca-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'fr-ca-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'fr-ca-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'fr-ca-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'en-ca-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'en-ca-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
      'fr-ca-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'fr-ca-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 CAD'),
      bannerSpendValue: _TL_('300 CAD'),
      couponValue: _TL_('CA$600'),
      spendValue: _TL_('CA$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Canada'),
    },
  },
  {
    sourceIdList: [
      'en-uk-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'en-uk-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'en-uk-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'en-uk-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'en-uk-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'en-uk-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'en-uk-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'en-uk-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 GBP'),
      bannerSpendValue: _TL_('200 GBP'),
      couponValue: _TL_('£400'),
      spendValue: _TL_('£200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('UK'),
    },
  },
  {
    sourceIdList: [
      'en-fr-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'en-fr-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'en-fr-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'en-fr-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'en-fr-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'en-fr-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'fr-fr-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'fr-fr-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'fr-fr-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'fr-fr-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'fr-fr-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'fr-fr-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'en-fr-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'en-fr-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
      'fr-fr-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'fr-fr-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('France'),
    },
  },
  {
    sourceIdList: [
      'en-de-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'en-de-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'en-de-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'en-de-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'en-de-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'en-de-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'de-de-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'de-de-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'de-de-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'de-de-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'de-de-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'de-de-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'en-de-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'en-de-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
      'de-de-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'de-de-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Germany'),
    },
  },
  {
    sourceIdList: [
      'ja-jp-acq-pm-src_ggl-sub_gglsb-flx_fy26englp',
      'ja-jp-acq-pm-src_ggl-sub_gglsc-flx_fy26englp',
      'ja-jp-acq-pm-src_ggl-sub_gglsnb-flx_fy26englp',
      'ja-jp-acq-pm-src_msa-sub_mssb-flx_fy26englp',
      'ja-jp-acq-pm-src_msa-sub_mssco-flx_fy26englp',
      'ja-jp-acq-pm-src_msa-sub_mssnb-flx_fy26englp',
      'ja-jp-acq-pm-src_ggl-sub_gpmax-flx_fy26englp',
      'ja-jp-acq-pm-src_msa-sub_mpmax-flx_fy26englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('60000 YEN'),
      bannerSpendValue: _TL_('30000 YEN'),
      couponValue: _TL_('¥60000'),
      spendValue: _TL_('¥30000'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Japan'),
    },
  },
  // FY27 englp source IDs
  {
    sourceIdList: [
      'en-au-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'en-au-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'en-au-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'en-au-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'en-au-acq-pm-src_msa-sub_mssb-flx_englp',
      'en-au-acq-pm-src_msa-sub_mssco-flx_englp',
      'en-au-acq-pm-src_msa-sub_mssnb-flx_englp',
      'en-au-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 AUD'),
      bannerSpendValue: _TL_('300 AUD'),
      couponValue: _TL_('A$600'),
      spendValue: _TL_('A$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Australia'),
    },
  },
  {
    sourceIdList: [
      'en-ca-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'fr-ca-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'en-ca-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'fr-ca-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'en-ca-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'fr-ca-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'en-ca-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'fr-ca-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'en-ca-acq-pm-src_msa-sub_mssb-flx_englp',
      'fr-ca-acq-pm-src_msa-sub_mssb-flx_englp',
      'en-ca-acq-pm-src_msa-sub_mssco-flx_englp',
      'fr-ca-acq-pm-src_msa-sub_mssco-flx_englp',
      'en-ca-acq-pm-src_msa-sub_mssnb-flx_englp',
      'fr-ca-acq-pm-src_msa-sub_mssnb-flx_englp',
      'en-ca-acq-pm-src_msa-sub_mpmax-flx_englp',
      'fr-ca-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('600 CAD'),
      bannerSpendValue: _TL_('300 CAD'),
      couponValue: _TL_('CA$600'),
      spendValue: _TL_('CA$300'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Canada'),
    },
  },
  {
    sourceIdList: [
      'en-de-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'de-de-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'en-de-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'de-de-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'en-de-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'de-de-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'en-de-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'de-de-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'en-de-acq-pm-src_msa-sub_mssb-flx_englp',
      'de-de-acq-pm-src_msa-sub_mssb-flx_englp',
      'en-de-acq-pm-src_msa-sub_mssco-flx_englp',
      'de-de-acq-pm-src_msa-sub_mssco-flx_englp',
      'en-de-acq-pm-src_msa-sub_mssnb-flx_englp',
      'de-de-acq-pm-src_msa-sub_mssnb-flx_englp',
      'en-de-acq-pm-src_msa-sub_mpmax-flx_englp',
      'de-de-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Germany'),
    },
  },
  {
    sourceIdList: [
      'en-fr-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'fr-fr-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'en-fr-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'fr-fr-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'en-fr-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'fr-fr-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'en-fr-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'fr-fr-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'en-fr-acq-pm-src_msa-sub_mssb-flx_englp',
      'fr-fr-acq-pm-src_msa-sub_mssb-flx_englp',
      'en-fr-acq-pm-src_msa-sub_mssco-flx_englp',
      'fr-fr-acq-pm-src_msa-sub_mssco-flx_englp',
      'en-fr-acq-pm-src_msa-sub_mssnb-flx_englp',
      'fr-fr-acq-pm-src_msa-sub_mssnb-flx_englp',
      'en-fr-acq-pm-src_msa-sub_mpmax-flx_englp',
      'fr-fr-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 EUR'),
      bannerSpendValue: _TL_('200 EUR'),
      couponValue: _TL_('€400'),
      spendValue: _TL_('€200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('France'),
    },
  },
  {
    sourceIdList: [
      'ja-jp-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'ja-jp-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'ja-jp-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'ja-jp-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'ja-jp-acq-pm-src_msa-sub_mssb-flx_englp',
      'ja-jp-acq-pm-src_msa-sub_mssco-flx_englp',
      'ja-jp-acq-pm-src_msa-sub_mssnb-flx_englp',
      'ja-jp-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('60000 YEN'),
      bannerSpendValue: _TL_('30000 YEN'),
      couponValue: _TL_('¥60000'),
      spendValue: _TL_('¥30000'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('Japan'),
    },
  },
  {
    sourceIdList: [
      'en-uk-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'en-uk-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'en-uk-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'en-uk-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'en-uk-acq-pm-src_msa-sub_mssb-flx_englp',
      'en-uk-acq-pm-src_msa-sub_mssco-flx_englp',
      'en-uk-acq-pm-src_msa-sub_mssnb-flx_englp',
      'en-uk-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('400 GBP'),
      bannerSpendValue: _TL_('200 GBP'),
      couponValue: _TL_('£400'),
      spendValue: _TL_('£200'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('UK'),
    },
  },
  {
    sourceIdList: [
      'en-us-acq-pm-src_ggl-sub_gglsb-flx_englp',
      'en-us-acq-pm-src_ggl-sub_gglsc-flx_englp',
      'en-us-acq-pm-src_ggl-sub_gglsnb-flx_englp',
      'en-us-acq-pm-src_ggl-sub_gpmax-flx_englp',
      'en-us-acq-pm-src_msa-sub_mssb-flx_englp',
      'en-us-acq-pm-src_msa-sub_mssco-flx_englp',
      'en-us-acq-pm-src_msa-sub_mssnb-flx_englp',
      'en-us-acq-pm-src_msa-sub_mpmax-flx_englp',
    ],
    template: CouponTemplates.Default,
    values: {
      bannerCouponValue: _TL_('500 USD'),
      bannerSpendValue: _TL_('250 USD'),
      couponValue: _TL_('$500'),
      spendValue: _TL_('$250'),
      expiryDate: _TL_('June 30, 2027'),
      market: _TL_('United States'),
    },
  },
];
